// extracted by mini-css-extract-plugin
export default {"buttonModal":"style_buttonModal__+PDob"};